<template lang="pug">
  v-row
    v-col(cols="12")
      v-card(flat).sdo-card
        v-card-text.pa-0
          enrollment-element(
            v-if="!$loader.isLoading"
            :enrollment="enrollment"
            :course="course"
            :stats="stats"
          )
            //- template(v-slot="{ }")
            router-view(
              :enrollment="enrollment"
              :course="course"
              :recorded.sync="stats.recorded"
              :waitForEnrollUsers.sync="stats.waitForEnrollUsers"
              :attestated.sync="stats.attestated"
              @update:enrollment="$emit('update:enrollment')"
            )
</template>

<script>
import EnrollmentElement from '@/modules/CourseManagement/components/Enrollment/EnrollmentElement.vue';

export default {
  name: 'CourseEnrollmentView',
  components: {
    EnrollmentElement,
  },
  data: () => ({
    course: null,
    groups: [],

    stats: {
      recorded: null,
      attestated: null,
      waitForEnrollUsers: null,
    },

    enrollment: {},
  }),
  computed: {
    enrollmentId() {
      return Number(this.$route.params.enrollmentId);
    },
    courseId() {
      return Number(this.$route.params.id);
    },
  },
  async created() {
    this.$loader.start();
    await this.fetchCourse();
    await this.fetchEnrollment();
    this.$loader.stop();
  },
  methods: {
    fetchEnrollment() {
      return this.$rHandler(
        this.$api.enrollments.getEnrollment(
          this.enrollmentId,
          { params: { expand: 'statements,telegram' } },
        ),
        ({ data }) => {
          this.enrollment = data.data;
          if (!this.enrollment.start_learning) {
            this.enrollment.start_learning = this.enrollment.period_start;
            this.enrollment.end_learning = this.enrollment.period_end;
          }
        },
      );
    },
    async fetchCourse() {
      const { item } = await this.$api.courses.show(this.courseId, { expand: 'course_units_count' });
      this.course = item;
      this.course.fetchGroups();
    },
  },
};
</script>
